import {
    monthlyOverviewChartInflowColor,
    monthlyOverviewChartOutflowColor,
} from "utils/chartColors";

const SvgGradients = () => {
    return (
        <>
            <svg width="0" height="0">
                <linearGradient
                    id="consola-gradient"
                    x1="7.44512"
                    y1="4.55858"
                    x2="21.0485"
                    y2="23.8488"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        stopColor={monthlyOverviewChartInflowColor}
                        offset="0%"
                    />
                    <stop
                        offset="100%"
                        stopColor={monthlyOverviewChartOutflowColor}
                    />
                </linearGradient>
            </svg>
        </>
    );
};

export default SvgGradients;
